import script from "./StoreManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreManagement.vue?vue&type=script&setup=true&lang=js"

import "./StoreManagement.vue?vue&type=style&index=0&id=208d9cef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208d9cef"]])

export default __exports__